module.exports = __webpack_public_path__ + "img/singapore-featured-image-1200x790.ded56914.jpg";